<template><div v-if="options_loaded && passed_filter && options_filter">
    <div class="form-group" :class="[!valid_selection ? 'has-error' : '']" :data-designer-component-id="component_id">
        <label :for="'question--' + component_id">{{ title }}</label>
        <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
            <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
        </select>
        <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
            <option>Loading Options...</option>
        </select>
    </div>
</div></template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Choose your Escutcheon Position';
                }
            },
            component_id: {
                default(){
                    return 'hardware_escutcheon_stable_position';
                }
            },
            hardwareEscutcheon: {
                required: true
            },
            slab: {
                required: true
            },
            frameMaterial: {
                required: true
            },
            doorRange: {
                default() {
                    return 0;
                }
            }
        },
        computed: {
            filtered_option_list(){
                if (Array.isArray(this.option_list)) {
                    return this.option_list.filter((key) => {
                        return key.value !== null;
                    });
                } else {
                    return [];
                }
            },
            passed_filter(){
                return this.variable_ready(this.slab, this.hardwareEscutcheon, this.frameMaterial);
            },
            options_filter(){
                return this.filtered_option_list.length > 1;
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-position?category=11&slab=' + this.slab + '&hardware_id=' + this.hardwareEscutcheon + '&frame_material=' + this.frameMaterial + '&door_range=' + this.doorRange;
            },
            cache_key(){
                return '_' + this.slab + '_' + this.hardwareEscutcheon + '_' + this.frameMaterial + '_' + this.doorRange;
            },
        },
        watch: {
            'hardwareEscutcheon': function (val, oldVal) {
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'frameMaterial': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
